function setWithinBounds(upperBound: number, lowerBound: number) {
  return (dimension: number) => dimension <= upperBound && dimension >= lowerBound;
}

/**
 * Ensure the dimensions are within reasonable bounds.
 */
export function dimensionsWithinBounds(dimensions: number[], bounds?: number[]): boolean {
  const lowerBound = bounds ? bounds[0] : 100;
  const upperBound = bounds ? bounds[1] : 3000;
  const withinBounds = setWithinBounds(lowerBound, upperBound);

  return dimensions.every(withinBounds);
}
